import { doc, onSnapshot } from "firebase/firestore"
import { inferencesTestRef } from "../services/database"

export async function checkInferenceResult(callback) {

    let unsub = onSnapshot(doc(inferencesTestRef, "llava"), (querySnapshot) => {

        const data = querySnapshot.data()
        callback(data)
    })
}